<template>
    <div class="flex flex-col bg-base">
        <div class="flex min-h-screen flex-col bg-base">
            <HeaderNew class="flex-none" />
            <CAlert v-if="infoAlertMessage" center full-width variant="info">
                <span v-html="infoAlertMessage"></span>
            </CAlert>
            <div class="flex-auto pb-8 pt-4 sm:pb-12 sm:pt-8 xl:pb-20 xl:pt-12">
                <slot />
            </div>
        </div>
        <AppFooter v-if="true" />
        <ClientOnly>
            <CookieBanner />
        </ClientOnly>
    </div>
</template>

<script setup lang="ts">
import type { UserProfile } from '#shared/types/User'
import { VisibilityType } from '#shared/types/visibility'
import HeaderNew from '@/components/header/HeaderNew.vue'
import { useApplicationStore } from '@/stores/application'

const route = useRoute()
const store = useApplicationStore()

const infoAlertMessage = ref('')

const userProfile = computed<UserProfile | undefined>(() => store.userProfile)

const _isOrganisation = computed(() => store.userOrgs.length !== 0)

const _isMentor = computed(() => userProfile.value?.mentorProfile?.visibility === VisibilityType.published)

const _isVolunteer = computed(() => userProfile.value?.volunteerProfile?.visibility === VisibilityType.published)

const trackGtmEvent = ref(false)
const trackGtmCode = ref('')

useHead(() => {
    if (!trackGtmEvent.value) return {}

    return {
        script: [
            {
                innerHTML: `
          window.dataLayer = window.dataLayer || [];
          window.dataLayer.push({${trackGtmCode.value}});
        `,
                type: 'text/javascript'
            }
        ]
    }
})

watch(route, () => {
    if (infoAlertMessage.value) {
        infoAlertMessage.value = ''
    }
})

// Provide functions globally to avoid redefinition errors
const addInfoMessage = (message: string) => {
    infoAlertMessage.value = message
}

// Kept for backward compatibility with pages that might still call these
const hideNavbarFunction = (value: boolean = true) => {
    // HeaderNew doesn't use this, but kept for compatibility
}

const setNavbarTheme = (theme: any) => {
    // HeaderNew doesn't use this, but kept for compatibility
}

provide('addInfoMessage', addInfoMessage)
provide('hideNavbar', hideNavbarFunction)
provide('navbarTheme', setNavbarTheme)

onMounted(() => {
    setTimeout(() => {
        trackGtmCode.value =
            `event: "user_info", user_id: ` +
            (userProfile.value ? `'${userProfile.value.id}'` : `"not_set"`) +
            `, is_mentor: ${_isMentor.value}, is_volunteer: ${_isVolunteer.value}` +
            ', is_organization: ' +
            _isOrganisation.value
        trackGtmEvent.value = true
    }, 1000)
})
</script>
